export const noop = (): void => {};

export const sanitizeHtml = (html: string | null | undefined): string => {
  return (
    html
      ?.replace?.(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "")
      ?.replace?.(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, "")
      ?.replace?.(/javascript:/gi, "")
      ?.replace?.(/on\w+="[^"]*"/gi, "") || ""
  );
};

export const truncateHtml = (
  html: string | null | undefined,
  maxLength: number = 300
): string => {
  if (!html) return "";

  const textOnly = html.replace(/<[^>]*>/g, "");

  if (textOnly.length <= maxLength) return html;

  let truncated = "";
  let textLength = 0;
  let inTag = false;

  for (let i = 0; i < html.length; i++) {
    const char = html[i];

    if (char === "<") {
      inTag = true;
    } else if (char === ">") {
      inTag = false;
    } else if (!inTag) {
      textLength++;
      if (textLength > maxLength) {
        break;
      }
    }

    truncated += char;
  }

  return truncated;
};

export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return "Data";

  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Data";

    const day = date.getUTCDate().toString().padStart(2, "0");
    const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error("Erro ao formatar data:", error);
    return "Data";
  }
};

export const formatSimpleDate = (
  dateString: string | null | undefined
): string => {
  if (!dateString) return "";

  if (dateString.includes("/")) return dateString;

  if (dateString.includes("-") && dateString.length === 10) {
    const parts = dateString.split("-");
    if (parts.length === 3) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
  }

  return dateString;
};

export const getText = (html: string): string => {
  const divContainer = document.createElement("div");
  divContainer.innerHTML = html;
  return divContainer.textContent || divContainer.innerText || "";
};
